module.exports = __webpack_public_path__ + "media/images/arrow-down-white-86db7c559cc57dbce95a527b3cf9265e.svg";